import { Steps } from 'antd'
import React from 'react'
import styled from 'styled-components'
import cx from 'classnames'
import { REPAIR_STATE } from '@services/repair'

const { Step } = Steps

type Props = { state: string }

function RepairSteps({ state, ...props }: Props) {
  const current = React.useMemo(() => {
    switch (state) {
      case REPAIR_STATE.REPORTED:
        return 0
      case REPAIR_STATE.REPAIRING:
        return 1
      case REPAIR_STATE.CLOSE:
      case REPAIR_STATE.FINISH:
        return 2
    }
  }, [state])
  return (
    <StyleSteps current={current} size="small">
      <Step
        icon={
          <IconState className={cx({ 'is--active': current === 0 })}>
            待派工
          </IconState>
        }
      />
      <Step
        icon={
          <IconState className={cx({ 'is--active': current === 1 })}>
            維修中
          </IconState>
        }
      />
      <Step
        icon={
          <IconState className={cx({ 'is--active': current === 2 })}>
            結 案
          </IconState>
        }
      />
    </StyleSteps>
  )
}

const StyleSteps = styled(Steps)`
  .ant-steps-item-title::after {
    background: #b68116 !important;
    left: auto !important;
  }
  .ant-steps-item {
    padding-left: 0px !important;
  }
  .ant-steps-item-icon {
    margin: 1px !important;
  }
`

const IconState = styled.div`
  width: 80px;
  height: 20px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #b68116;
  border: solid 1.2px #b68116;
  background-color: rgba(182, 129, 22, 0.1);

  &.is--active {
    color: #fff;
    background-color: #b68116;
  }
`

export default RepairSteps
